var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 18.5001C12.7533 18.5001 8.5 22.7534 8.5 28.0001C8.5 33.2468 12.7533 37.5001 18 37.5001V38.5001C12.201 38.5001 7.5 33.7991 7.5 28.0001C7.5 22.2011 12.201 17.5001 18 17.5001C23.799 17.5001 28.5 22.2011 28.5 28.0001H27.5C27.5 22.7534 23.2467 18.5001 18 18.5001Z",
    fill: "#2C666E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5 7.29297L37.3536 10.1465L36.6464 10.8536L35 9.20718V14.5001C35 16.1569 36.3431 17.5001 38 17.5001V18.5001C35.7909 18.5001 34 16.7092 34 14.5001V9.20718L32.3536 10.8536L31.6464 10.1465L34.5 7.29297Z",
    fill: "#2C666E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 48.7072L18.6464 45.8536L19.3536 45.1465L21 46.793V41.5001C21 39.8432 19.6569 38.5001 18 38.5001V37.5001C20.2091 37.5001 22 39.2909 22 41.5001V46.793L23.6464 45.1465L24.3536 45.8536L21.5 48.7072Z",
    fill: "#2C666E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 28.0001C47.5 22.7534 43.2467 18.5001 38 18.5001V17.5001C43.799 17.5001 48.5 22.2011 48.5 28.0001C48.5 33.7991 43.799 38.5001 38 38.5001C32.201 38.5001 27.5 33.7991 27.5 28.0001H28.5C28.5 33.2468 32.7533 37.5001 38 37.5001C43.2467 37.5001 47.5 33.2468 47.5 28.0001Z",
    fill: "#2C666E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 36.0001L31.0718 32.0001V24.0001L38 20.0001L44.9282 24.0001V32.0001L38 36.0001ZM38.5 34.5567V28.2887L43.9282 25.1548V31.4227L38.5 34.5567ZM43.4282 24.2887L38 27.4227L32.5718 24.2887L38 21.1548L43.4282 24.2887ZM32.0718 25.1548L37.5 28.2887V34.5567L32.0718 31.4227V25.1548Z",
    fill: "#2C666E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 20.0001L11.0718 24.0001V32.0001L18 36.0001L24.9282 32.0001V24.0001L18 20.0001ZM18.5 21.4435V27.7114L23.9282 30.8454V24.5774L18.5 21.4435ZM23.4282 31.7114L17.9987 28.5767L12.5425 31.6945L18 34.8454L23.4282 31.7114ZM12.0718 30.8118L17.5 27.7099V21.4435L12.0718 24.5774V30.8118Z",
    fill: "#2C666E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 31.0001C39.6569 31.0001 41 29.6569 41 28.0001C41 26.3432 39.6569 25.0001 38 25.0001C36.3431 25.0001 35 26.3432 35 28.0001C35 29.6569 36.3431 31.0001 38 31.0001ZM38 32.0001C40.2091 32.0001 42 30.2092 42 28.0001C42 25.7909 40.2091 24.0001 38 24.0001C35.7909 24.0001 34 25.7909 34 28.0001C34 30.2092 35.7909 32.0001 38 32.0001Z",
    fill: "#2C666E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 31.0001C19.6569 31.0001 21 29.6569 21 28.0001C21 26.3432 19.6569 25.0001 18 25.0001C16.3431 25.0001 15 26.3432 15 28.0001C15 29.6569 16.3431 31.0001 18 31.0001ZM18 32.0001C20.2091 32.0001 22 30.2092 22 28.0001C22 25.7909 20.2091 24.0001 18 24.0001C15.7909 24.0001 14 25.7909 14 28.0001C14 30.2092 15.7909 32.0001 18 32.0001Z",
    fill: "#2C666E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevops);
export default __webpack_public_path__ + "static/media/devops.2cfac20956db844843886b4e34734a88.svg";
export { ForwardRef as ReactComponent };